import React, { useEffect, useState, useReducer } from 'react';
import App from './App';
import { Link, useNavigate } from 'react-router-dom';
import bg from './trial.jpeg';
import logo from './logo.png';
import { fetchbygetmethod, myreducer, initialstate } from './Commonfiles/Myreducer';
//import ImageSlider from './ImageSlider';
import './loginpage.css'
import banner from './loginpage.png'
export default function Login() { 
	const images = [
		
	  ];
	  var [isfreshlogin,setisfreshlogin]=useState(true);
	var [errstatus, seterrstatus] = useState(0);
	const navigate = useNavigate();
	const [mydata, setmydata] = useReducer(myreducer, initialstate);// useReducer(initialstate,myreducer);
	const [myadmindata, setmyadmindata] = useReducer(myreducer, initialstate);// useReducer(initialstate,myreducer);
	//let [ispanellogin,setispanellogin]=useState(0);
	let ispanellogin = 0, loginpanelprocess = 0;
	//alert('display'+ispanellogin);
	function checklogin() {
		//alert('2'); 
		setisfreshlogin(false);
        clearsessionStorage();
		checkpanellogin();
		//alert('ispanellogin==',ispanellogin);
		//if(ispanellogin==0 && loginpanelprocess==1)




	}
	function clearsessionStorage()
    {
        sessionStorage.clear();
      
    }
	
	function checkpanellogin() {
		clearsessionStorage();
		var uname = document.getElementById("uname").value;
		var pwd = document.getElementById("pwd").value;

		console.log("uname", uname);
		console.log("pwd", pwd);

		//   if (uname && !uname.trim().toLowerCase().startsWith('ds')) {
		// 			alert('Please Fill Your DS ID');
		// 			return;
		// 		}
				
		// 	else{
		// 		fetchbygetmethod(setmydata, 'login', { uname: uname, passd: pwd });}
	
		fetchbygetmethod(setmydata, 'login', { uname: uname, passd: pwd });
			


	}
	function setpanellogin()
	{
		//alert('3');
		
			if (mydata.token && mydata.mypost.length>0) { 

				sessionStorage.setItem("tempID", mydata.mypost[0].TempID);
				//console.log("1");
				sessionStorage.setItem("applicantID", mydata.mypost[0].ApplicantId);
				sessionStorage.setItem("applicantType", mydata.mypost[0].ApplicantType.trim());
				//sessionStorage.setItem("LoginUser",d[0].ApplicantType.trim());
				sessionStorage.setItem("token", mydata.token);

				console.log(sessionStorage.getItem("tempID"));
				console.log(sessionStorage.getItem("applicantID"));
				console.log(sessionStorage.getItem("applicantType"));
				//ispanellogin=1;
				//alert('1ispanellogin=='+ispanellogin);//+"temp="+temp);
				ispanellogin = 1;

			   window.location.reload();
			}
			
		
	
	}
	
	useEffect(()=>{
		                  console.log("useffect mydata", mydata);
							if(isfreshlogin==false)setpanellogin();},[mydata]);
	
							return (
								<div className='JMVDLoginPage'>
								  <div className='JMVDLoginSpotlight'>
									{/* Spotlight content can go here */}
								  </div>
								  <div className='JMVDLoginForm'>
									<div className="JMVDLoginLogo">
									  <img src={logo} alt="JMVD Logo" />
									</div>
									<div className='JMVDLoginFormContents'>
									  <div className='JMVDLoginFormTitle'>
										<h2>Welcome To JMVD Family</h2>
										<span>Please Sign In</span>
									  </div>
									  <form className="JMVDLoginFormElement">
										<div className="JMVDLoginFormGroup">
										  <div className="JMVDLoginFormControl">
											<input id="uname" className="JMVDLoginInput" type="text" required placeholder="Username" />
										  </div>
										</div>
										<div className="JMVDLoginFormGroup">
										  <div className="JMVDLoginFormControl">
											<input id="pwd" className="JMVDLoginInput" type="password" required placeholder="Password" />
										  </div>
										</div>
										<div className="JMVDLoginFormGroup">
										  <div className="JMVDLoginFormControl">
											<div className="JMVDLoginCheckbox">
											  <input id="checkbox-signup" type="checkbox" /> 
											  <label htmlFor="checkbox-signup">Remember me</label>
											</div>
										  </div>
										</div>
										<div className="JMVDLoginFormGroupCenter">
										  <div className="JMVDLoginFormControl">
											<input 
											  type='button' 
											  value='Log In' 
											  onClick={checklogin}
											  className="JMVDLoginButton"
											/>
											{errstatus === 1 && <label className="JMVDLoginError">Invalid Username or Password</label>}
										  </div>
										</div>
									  </form>
									</div>
								  </div>
								</div>
							  )
							  
}